import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@material-ui/core/Button";
import CardBody from "components/Card/CardBody.js";
import Card from "components/MyComponents/Card.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import styles from "assets/jss/material-kit-react/views/loginPage.js";

import Grid from '@material-ui/core/Grid';


import axios from 'axios';
import { useTranslation, Trans } from 'react-i18next';
import config from "assets/config/config.json"
import SEPATool from "services/IBANSepaChecker"
import BICSepa from "assets/config/BICSepa.json"

import ClipLoader from "react-spinners/ClipLoader";
import { Box, Modal, styled } from "@material-ui/core";
import SavedModal from "components/MyComponents/SavedModal";
import LoadingSpinner from "components/MyComponents/LoadingSpinner";
import { withRouter } from "react-router-dom";
import CardErrorModal from "components/MyComponents/CardErrorModal";

//IBAN and BIC validation
const ibantools = require('ibantools');
const useStyles = makeStyles(styles);

function PaymentFormOverviewComponent(props) {
    const { history } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    const { ...rest } = props;
    const [loading, setLoading] = React.useState(false);
    const [bankAccountOpen, setBankAccountOpen] = React.useState(false);
    const [installmentsOpen, setInstallmentsOpen] = React.useState(false);

    const { showSavedModalOpen, showCardErrorModalOpen } = props;
    let showSavedModalOpened = false;
    let showCardErrorModalOpened = false;
    if (showSavedModalOpen) {
        if (showCardErrorModalOpen) {
            showCardErrorModalOpened = true;
        } else {
            showSavedModalOpened = true;
        }
    }
    const [savedModalOpen, setSavedModalOpen] = React.useState(showSavedModalOpened);
    const [cardErrorModalOpen, setCardErrorModalOpen] = React.useState(showCardErrorModalOpened);
    const [state, setState] = React.useState({
        name: undefined,
        surname: undefined,
        program: undefined,
        iban: '',
        bic: '',
        quote: 0,
        alreadyPaid: undefined,
        toPay: undefined,
        currentInstallments: 1,
        userId: undefined,
        installments: 1,
        currentFutureInstallments: 1,
        currentIban: undefined,
        curentExpDate: undefined,
        terms: undefined,
        nextTerms: undefined,
        sepaAgreed: false,
        hasToDisplaySepa: true,
        correct: false,
        correctIban: true,
        correctBic: true,
        amount: '455',
        isnotsubscribed: false,
        showTwelveInstallments: false,
        termsAgreed: false,
        showTermsAgreedError: false
    });
    // similar to componentDidMount()
    React.useEffect(() => {
        if (props.userData) {
            var d = new Date(props.userData.paymentInfo?.expirationDate);
            var month = d ? d.getMonth() + 1 : 0;
            var year = d ? d.getFullYear() : 0;
            var middle = props.userData.termId.length / 2;
            var firstYear = '20' + props.userData.termId.substr(0, middle);
            var secondYear = '20' + props.userData.termId.substr(middle);
            setState({
                ...state,
                ['name']: props.userData.name,
                ['surname']: props.userData.surname,
                ['program']: props.userData.program,
                ['quote']: props.userData.amount.toFixed(2),
                ['alreadyPaid']: props.userData.alreadyPaid.toFixed(2),
                ['toPay']: (props.userData.amount - props.userData.alreadyPaid).toFixed(2),
                ['currentInstallments']: props.userData.currentInstallments === -1 ? 1 : props.userData.currentInstallments,
                ['userId']: props.userData.userId,
                ['installments']: props.userData.installments === -1 ? 1 : props.userData.installments,
                ['currentFutureInstallments']: props.userData.installments === -1 ? 1 : props.userData.installments,
                ['currentIban']: props.userData.paymentInfo?.ibanFirstLetters ? props.userData.paymentInfo?.ibanFirstLetters + "*******" + props.userData.paymentInfo?.ibanLastDigits : undefined,
                ['curentExpDate']: props.userData.paymentInfo?.expirationDate ? month + "/" + year : undefined,
                ['terms']: firstYear + "/" + secondYear,
                ['nextTerms']: (Number(firstYear) + 1) + "/" + (Number(secondYear) + 1),
                ['isnotsubscribed']: props.userData.isnotsubscribed,
                ['showTwelveInstallments']: props.userData.installments === 12

            });
        }
    }, [])
    const isNullorWhiteSpace = function (input) {
        return !/\S/.test(input);
    }
    const validateEmail = function (email) {
        return /\S+@\S+\.\S+/.test(email);
    }
    const validateIBAN = function (iban) {

        return ibantools.isValidIBAN(iban);
    }
    const validateBIC = function (bic) {
       const isValidBic = ibantools.isValidBIC(bic);
       const bicobject = isValidBic && ibantools.extractBIC(bic);
       return isValidBic && BICSepa["BICSepaCodeList"].includes(bicobject.countryCode);
    }
    const handleTermsAgreement = function (event) {
        setState({
            ...state,
            ['termsAgreed']: event.target.checked,
            ['showTermsAgreedError']: !event.target.checked
        });
        if (event.target.checked) {
            document.getElementById("info").style.visibility = "hidden";
        }
    }
    const setAllWrong = function () {
        setState({
            ...state,
            ['correctIban']: validateIBAN(state.iban),
            ['correctBic']: validateBIC(state.bic),
        });
        document.getElementById("info").style.visibility = "visible";
    }
    const setTermsIncorrect = function () {
        setState({
            ...state,
            ['showTermsAgreedError']: true
        });
        document.getElementById("info").style.visibility = "visible";
        window.scrollTo({ top: 0, behavior: 'smooth' });

    }
    const disableAllButtons = function () {
        setLoading(true);
        // document.getElementById("BankButtonEnabled").style.pointerEvents = "none"; // NO ideal pero funcional
        // document.getElementById("BankButtonEnabled").style.display = "none";
        // document.getElementById("RedsysEnabled").style.pointerEvents = "none"; 
        // document.getElementById("RedsysEnabled").style.display = "none";
        // document.getElementById("openAddCreditCard").style.pointerEvents = "none";
        // document.getElementById("openAddCreditCard").style.display = "none";
    }
    const enableAllButtons = function () {
        setLoading(false);
        // document.getElementById("BankButtonEnabled").style.pointerEvents = "all"; // NO ideal pero funcional
        // document.getElementById("BankButtonEnabled").style.display = "initial";
        // document.getElementById("RedsysEnabled").style.pointerEvents = "all"; 
        // document.getElementById("RedsysEnabled").style.display = "initial";
        // document.getElementById("openAddCreditCard").style.pointerEvents = "all";
        // document.getElementById("openAddCreditCard").style.display = "initial";
    }
    const handleInstallmentsChange = function (event) {
        setState({
            ...state,
            ['installments']: event.target.value
        });
    }
    const handleSepaAgreement = function (event) {
        setState({
            ...state,
            ['sepaAgreed']: event.target.checked,

        });
    }
    const notifyUser = function (iban, bic) {

        if (document.getElementById("menu").getAttribute("value") === "0" && (!iban || !bic)) {
            document.getElementById("info").style.visibility = "visible"
        }
        else {
            document.getElementById("info").style.visibility = "hidden"
        }

    }
    const handleChange = name => event => {
        let bicCheck = (name === "bic") ? validateBIC(event.target.value.replace(/\s/g, '')) : state.correctBic;
        let ibanCheck = state.correctIban;
        let hasToDisplaySepa = state.hasToDisplaySepa;
        let correctedvalue = (name === "iban" || name === "bic") ? event.target.value.replace(/\s/g, '') : event.target.value;
        if (name === "iban") {
            ibanCheck = validateIBAN(event.target.value.replace(/\s/g, ''));
            bicCheck = validateBIC(document.getElementById('bic').value.replace(/\s/g, ''));
            hasToDisplaySepa = SEPATool(event.target.value);
        }
        // notifyUser(ibanCheck, bicCheck);
        // state[name] = (name === "iban" || name === "bic")? event.target.value.replace(/\s/g,''): event.target.value;

        setState({
            ...state,
            [name]: correctedvalue,
            ['correctIban']: ibanCheck,
            ['correctBic']: bicCheck,
            ['hasToDisplaySepa']: hasToDisplaySepa,
        });
    }
    const handleSubmissionBankAccount = (event) => {
        if (!validateIBAN(state.iban) || !validateBIC(state.bic) || !state.sepaAgreed || !state.hasToDisplaySepa) {
            setAllWrong();
            return;
        }

        disableAllButtons();
        const client = {
            IBAN: state.iban,
            BIC: state.bic,
            amount: state.quote.toString(),
            installments: state.installments.toString(),
            isnotsubscribed: state.isnotsubscribed
        };
        //let username = Math.random().toString(36).substring(7);
        //const password = config.password;
        //const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64');
       axios.post(props.userData.bankPayment, client
          //,
          //  {
          //      headers:
          //      {
          //          'Authorization': "Basic " + token
          //      }
          //  }
        )
            .then(res => {
                //history.push('/success');
                setBankAccountOpen(false);
                setState({
                    ...state,
                    ['currentIban']: state.iban.slice(0, 4) + "*******" + state.iban.slice(state.iban.length - 5, state.iban.length - 1),
                    ['curentExpDate']: undefined,
                });
                setSavedModalOpen(true);
                enableAllButtons();

                return;
            }).catch(function (error) {
                if (error.response !== undefined && error.response.status !== null && error.response.status === 400) {
                    document.getElementById("info").style.visibility = "visible";
                }
                else {
                    document.getElementById("error").style.visibility = 'visible';
                }

                enableAllButtons();
            });

    }
    const handleSubmissionCreditCard = (event) => {
        disableAllButtons();
        const client = {
            amount: state.quote.toString(),
            installments: state.installments.toString(),
            isnotsubscribed: state.isnotsubscribed
        };
        //let username = Math.random().toString(36).substring(7);
        //const password = config.password;
        //const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64');
       axios.post(props.userData.cardPayment, client
          //,
          //  {
          //      headers:
          //      {
          //          'Authorization': "Basic " + token
          //      }
          //  }
        )
            .then(res => {
                document.getElementById('merchantParams').value = res.data.merchantParams;
                document.getElementById('signature').value = res.data.signature;
                document.getElementById('elForm').submit();
            }).catch(error => {
                if (error.response !== undefined && error.response.status !== null && error.response.status === 400) {
                    document.getElementById("info").style.visibility = "visible";
                }
                else {
                    document.getElementById("error").style.visibility = 'visible';

                }
                enableAllButtons();
            });
    }
    const handleSubmissionInstallments = (event) => {
        disableAllButtons();
        const client = {
            installments: state.installments.toString()
        };
        //let username = Math.random().toString(36).substring(7);
        //const password = config.password;
        //const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64');
       axios.post('/saveinstallments', client
          //,
          //  {
          //      headers:
          //      {
          //          'Authorization': "Basic " + token
          //      }
          //  }
        )
            .then(res => {
                state.currentFutureInstallments = state.installments;
                setInstallmentsOpen(false);
                setSavedModalOpen(true);
                enableAllButtons();

                return;
            }).catch(function (error) {
                if (error.response !== undefined && error.response.status !== null && error.response.status === 400) {
                    document.getElementById("info").style.visibility = "visible";
                }
                else {
                    document.getElementById("error").style.visibility = 'visible';
                }

                enableAllButtons();
            });

    }

    if (!props.userData) return (null);
    else if (state.loading) {
        return (<div
            style={{
                position: 'absolute', left: '50%', top: '50%',
                transform: 'translate(-50%, -50%)'
            }}
        >
            <ClipLoader

                size={200}
                color={"#504a4a"}
            />
        </div>);
    }
    //let cardsToPay = [];
    //const intallmentPayment = (state.quote / state.currentInstallments).toFixed(2);
    //{
    //    (function (rows, i, len) {
    //        while (++i <= len) {
    //            rows.push(<Card key={i}
    //                header={(state.alreadyPaid >= intallmentPayment * i ? t("PaidText") : t("PendingText")) + " (" + i.toString().padStart(2, "0") + "/" + state.currentInstallments.toString().padStart(2, "0") + ")"}
    //                body={intallmentPayment.toString()}
    //                footer={state.terms}></Card>)
    //        }
    //        return rows;
    //    })(cardsToPay, 0, state.currentInstallments)
    //}

    const modalBody = (
        <Box bgcolor="white" borderRadius={16} p={4} width={{ xs: "80%", md: "60%" }}
        style={{maxHeight: '80%', overflow: 'auto'}}>
            <div className="semibold-b400 paddingBottom16" style={{ textAlign: "center" }}>{t("BankAccountModalTitle")}</div>
            <div className="regular-b400" style={{ textAlign: "center" }}>{t("BankAccountDescription")}</div>
            <div>
                <CustomInput
                    labelText="IBAN*"
                    placeholder="XX00000000000000000000"
                    id="account"
                    formControlProps={{
                        fullWidth: true
                    }}
                    helperMessage={(!state.hasToDisplaySepa && state.correctIban) ? t("NOTSEPAErrorText") : t("IbanError")}
                    inputProps={{
                        value: state.iban,
                        type: "account"
                    }}
                    error={!state.hasToDisplaySepa || !state.correctIban}
                    onChange={handleChange('iban')}
                />
            </div>
            <div>
                <CustomInput
                    labelText={t("BIC (Swift Code)*")}
                    placeholder="XXXXXXXXXXX"
                    id="bic"
                    formControlProps={{
                        fullWidth: true
                    }}
                    inputProps={{
                        value: state.bic
                    }}
                    helperMessage={t("BicError")}
                    error={!state.correctBic}
                    onChange={handleChange('bic')}
                />
            </div>
            <div className={classes.spacing}></div>
            {!state.sepaAgreed ? <FormHelperText error >{t("SepaNoteAccept")}</FormHelperText> : ""}

            <FormControlLabel

                control={
                    <Checkbox
                        className={classes.checkBox}
                        color="default"
                        checked={state.sepaAgreed}
                        onChange={handleSepaAgreement}
                        name="sepaok"
                    />
                }
                label={t("SepaNoteLabel")}
                className={classes.regularText + " semibold-b300"}
            />

            <p className={classes.regularText + " regular-b300 cl-primary-100"}>{t("SEPANoteText")}</p>
            <div className={classes.spacing}></div>
            <GridContainer justify="center" className="paddingBottom12">
                {/* <CustomButton id="BankButtonEnabled" color="white" size="lg"  onClick={handleSubmissionBankAccount}>
                    {t("Save")}
                </CustomButton> */}
                <Button id="BankButtonEnabled" className="regular-b300 cl-secondary-100 myIeseButton" variant="text" onClick={handleSubmissionBankAccount}>
                    {t("Save")}
                </Button>
            </GridContainer>
            <GridContainer justify="center">
                <Button className="regular-b200 cl-secondary-900" variant="text" onClick={e => setBankAccountOpen(false)}>
                    {t("Cancel")}
                </Button>
            </GridContainer>
        </Box>
    );
    const bankAccountModal = <Modal
        open={bankAccountOpen}
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}
        onClose={e => setBankAccountOpen(false)}
    >
        {modalBody}
    </Modal>;
    const cancelEditInstallments = (event) => {
        state.installments = state.currentFutureInstallments;
        setInstallmentsOpen(false);
    };
    const installmentsmodalBody = (
        <Box bgcolor="white" borderRadius={16} p={4} width={{ xs: "80%", md: "40%" }}
        style={{maxHeight: '80%', overflow: 'auto'}}>
            <div className="regular-b400 paddingBottom32" style={{ textAlign: "center" }}>{t("InstallmentsEditModalTitle")}
                <span className="semibold-b400">{state.nextTerms}</span>
            </div>
            <div className="bg-brown-lighter padding32">
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={state.installments.toString()}
                    name="radio-buttons-group"
                    onChange={handleInstallmentsChange}
                >
                    <FormControlLabel style={{ padding: "8px 0" }} value="1" control={<Radio />}
                        label={<div>
                            <div className="regular-b300">{t("OneInstallment")}</div>
                            <div className="regular-b300 cl-secondary-500">{(state.quote != undefined ? state.quote.toString().replace(".", ",") : "") + "€" + t("OneInstallmentHint")}</div>
                        </div>} />
                    <FormControlLabel style={{ padding: "8px 0" }} value="2" control={<Radio />}
                        label={<div>
                            <div className="regular-b300">{t("TwoInstallment")}</div>
                            <div className="regular-b300 cl-secondary-500">{(state.quote != undefined ? (state.quote / 2).toFixed(2).toString().replace(".", ",") : "") + "€" + t("TwoInstallmentHint")}</div>
                        </div>} />
                    {/* <FormControlLabel style={{ padding: "8px 0" }} value="3" control={<Radio />}
                        label={<div>
                            <div className="regular-b300">{t("ThreeInstallment")}</div>
                            <div className="regular-b300 cl-secondary-500">{(state.quote != undefined ? (state.quote / 3).toFixed(2).toString().replace(".", ",") : "") + "€" + t("ThreeInstallmentHint")}</div>
                        </div>} /> */}
                    <FormControlLabel style={{ padding: "8px 0" }} value="4" control={<Radio />}
                        label={<div>
                            <div className="regular-b300">{t("FourInstallment")}</div>
                            <div className="regular-b300 cl-secondary-500">{(state.quote != undefined ? (state.quote / 4).toFixed(2).toString().replace(".", ",") : "") + "€" + t("FourInstallmentHint")}</div>
                        </div>} />
                    {state.showTwelveInstallments &&
                    <FormControlLabel style={{ padding: "8px 0" }} value="12" control={<Radio />}
                        label={<div>
                            <div className="regular-b300">{t("TwelveInstallment")}</div>
                            <div className="regular-b300 cl-secondary-500">{(state.quote != undefined ? (state.quote / 12).toFixed(2).toString().replace(".", ",") : "") + "€" + t("TwelveInstallmentHint")}</div>
                        </div>} />}
                </RadioGroup>
            </div>
            <div className={classes.spacing}></div>
            <GridContainer justify="center" className="paddingBottom12">
                <Button id="EditInstallmentsButtonEnabled" className="regular-b300 cl-secondary-100 myIeseButton" variant="text" onClick={handleSubmissionInstallments}>
                    {t("Save")}
                </Button>
            </GridContainer>
            <GridContainer justify="center">
                <Button className="regular-b200 cl-secondary-900" variant="text" onClick={e => cancelEditInstallments(false)}>
                    {t("Cancel")}
                </Button>
            </GridContainer>
        </Box>
    );
    const installmentsModal = <Modal
        open={installmentsOpen}
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}
        onClose={e => setInstallmentsOpen(false)}
    >
        {installmentsmodalBody}
    </Modal>;
    const buttonAddBankAccount = <Button className="semibold-b300" variant="text" id="openAddBankAccount" onClick={e => !state.termsAgreed ? setTermsIncorrect() : setBankAccountOpen(true)}>{t("ChangeDefaultMethodBtnText")}</Button>;
    const buttonEditBankAccount = <Button className="semibold-b300" variant="text" id="openAddBankAccount" onClick={e => !state.termsAgreed ? setTermsIncorrect() : setBankAccountOpen(true)}>{t("EditBtnText")}</Button>;
    const buttonAddCreditCard = <Button className="semibold-b300" variant="text" id="openAddCreditCard" onClick={e => !state.termsAgreed ? setTermsIncorrect() : handleSubmissionCreditCard(e)}>{t("ChangeDefaultMethodBtnText")}</Button>;
    const buttonEditCreditCard = <Button className="semibold-b300" variant="text" id="openAddCreditCard" onClick={e => !state.termsAgreed ? setTermsIncorrect() : handleSubmissionCreditCard(e)}>{t("EditBtnText")}</Button>;
    const buttonEditInstallments = <Button className="semibold-b300 verticalAlignTop" variant="text" id="openEditInstallments" onClick={e => !state.termsAgreed ? setTermsIncorrect() : setInstallmentsOpen(true)}>{t("EditBtnText")}</Button>;

    return (
        <GridContainer justify="center">
            {loading ? <LoadingSpinner /> : ""}
            <GridItem xs={12} sm={12} md={12}>
                <form className={classes.form} style={{ borderRadius: "8px" }}>
                    <CardBody>
                        {/* <Grid container spacing={1} className="PaymentMethodBackgroundColor" justify="center">
                            <Grid className="padding4to30" item xs={12} sm={12} md={12}>
                                <div className={"semibold-h300 cl-secondary-100 paddingTop60"}> {t("PaymentMethod")}</div>
                                <div className={classes.spacing}></div>
                                <div className="myCardWrapper">
                                    <Card header={t("FeeText")} body={state.quote} footer={state.terms}></Card>
                                    {cardsToPay}
                                </div>
                            </Grid> */}
                        <Grid className="paddingLeftRight64" item xs={12} sm={12} md={12}>
                            <div className={"semibold-h500 paddingTop64 paddingTop40Mobile"}> {t("PaymentMethod")}</div>
                            <Grid item xs={12} sm={12} md={6} className="paddingTop20">
                                {state.showTermsAgreedError ? <FormHelperText error >{t("RequiredFieldError")}</FormHelperText> : ""}
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            className={classes.checkBox + " MyCheckbox"}
                                            color="default"
                                            checked={state.termsAgreed}
                                            onChange={handleTermsAgreement}
                                            name="termsAgreedOk"
                                        />
                                    }
                                    label={<>{t("PersonalInformation_AgreeTerms")}<a target='_blank' href={t("PersonalInformation_AgreeTermsOfUseUrl")}>{t("PersonalInformation_AgreeTermsOfUse")}</a>{t("PersonalInformation_AgreeTermsAnd")}<a target='_blank' href={t("PersonalInformation_AgreeTermsPrivacyUrl")}>{t("PersonalInformation_AgreeTermsPrivacy")}</a><Trans i18nKey="PersonalInformation_AgreeTermsInfo" components={{ bold: <b /> }} /></>}
                                    className={classes.regularText + " regular-b200 textDecorationUnderline MyCheckboxWrapper"}
                                />
                            </Grid>
                            <div className="flexWrapper equals paddingTop60">
                                <div className={classes.gridFirstColumn}>
                                    <div className="semibold-h200 paddingBottom16">{t("NumberInstallments")}</div>
                                    <div className="semibold-b100 cl-secondary-500">{t("InstallmentsDescription")}</div>
                                </div>
                                <div>
                                    <div className="myPaymentCard">
                                        <div className="paddingBottom20">
                                            <div className="flexWrapper">
                                                <div>
                                                    <div className="semibold-b300">
                                                        {state.installments == 1 && t("OneInstallment")}
                                                        {state.installments == 2 && t("TwoInstallment")}
                                                        {state.installments == 3 && t("ThreeInstallment")}
                                                        {state.installments == 4 && t("FourInstallment")}
                                                        {state.installments == 12 && t("TwelveInstallment")}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="textRight">
                                                        <a className='semibold-b300 anchor'
                                                            onClick={e => !state.termsAgreed ? setTermsIncorrect() : setInstallmentsOpen(true)}>
                                                            {t("EditBtnText")}<img loading="lazy"
                                                                className="gotopageimg"
                                                                alt={t("EditBtnText")} src="/img/rightarrow.svg" /></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="regular-b200 paddingBottom20">{t("InstallmentsEditDescription")}</div>
                                        <div>
                                            <span className="regular-b200 cl-secondary-500">
                                                {state.installments == 1 && (state.quote != undefined ? state.quote.toString().replace(".", ",") : "") + "€" + t("OneInstallmentHint")}
                                                {state.installments == 2 && (state.quote != undefined ? (state.quote / 2).toFixed(2).toString().replace(".", ",") : "") + "€" + t("TwoInstallmentHint")}
                                                {state.installments == 3 && (state.quote != undefined ? (state.quote / 3).toFixed(2).toString().replace(".", ",") : "") + "€" + t("ThreeInstallmentHint")}
                                                {state.installments == 4 && (state.quote != undefined ? (state.quote / 4).toFixed(2).toString().replace(".", ",") : "") + "€" + t("FourInstallmentHint")}
                                                {state.installments == 12 && (state.quote != undefined ? (state.quote / 12).toFixed(2).toString().replace(".", ",") : "") + "€" + t("TwelveInstallmentHint")}
                                            </span>
                                        </div>
                                    </div>


                                    {/* <div className="regular-b300 paddingBottom16">{t("InstallmentsEditDescription") + state.nextTerms}</div>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        value={state.installments.toString()}
                                        name="radio-buttons-group"
                                    // onChange={handleInstallmentsChange}
                                    >
                                        <div><FormControlLabel disabled style={{ padding: "8px 0" }} className={(state.installments != 1 ? "opacity04" : "") + " MyCheckboxWrapper"} value="1" control={<Radio className="MyCheckbox" />}
                                            label={<div>
                                                <div className="regular-b300">{t("OneInstallment")}</div>
                                                <div className="regular-b300 cl-secondary-500">{(state.quote != undefined ? state.quote.toString().replace(".", ",") : "") + "€" + t("OneInstallmentHint")}</div>
                                            </div>} />{state.installments == 1 ? buttonEditInstallments : ""}</div>
                                        <div><FormControlLabel disabled style={{ padding: "8px 0" }} className={(state.installments != 2 ? "opacity04" : "") + " MyCheckboxWrapper"} value="2" control={<Radio className="MyCheckbox" />}
                                            label={<div>
                                                <div className="regular-b300">{t("TwoInstallment")}</div>
                                                <div className="regular-b300 cl-secondary-500">{(state.quote != undefined ? (state.quote / 2).toFixed(2).toString().replace(".", ",") : "") + "€" + t("TwoInstallmentHint")}</div>
                                            </div>} />{state.installments == 2 ? buttonEditInstallments : ""}</div>
                                        <div><FormControlLabel disabled style={{ padding: "8px 0" }} className={(state.installments != 4 ? "opacity04" : "") + " MyCheckboxWrapper"} value="4" control={<Radio className="MyCheckbox" />}
                                            label={<div>
                                                <div className="regular-b300">{t("FourInstallment")}</div>
                                                <div className="regular-b300 cl-secondary-500">{(state.quote != undefined ? (state.quote / 4).toFixed(2).toString().replace(".", ",") : "") + "€" + t("FourInstallmentHint")}</div>
                                            </div>} />{state.installments == 4 ? buttonEditInstallments : ""}</div>
                                    </RadioGroup> */}
                                </div>
                                {installmentsModal}
                            </div>
                        </Grid>
                        <hr className="customHr marginLeftRight64 paddingLeftRight64 customHrWidthLeftRightMobile" />
                        <Grid className="paddingLeftRight64" item xs={12} sm={12} md={12}>
                            <div className="flexWrapper equals">
                                <div className={classes.gridFirstColumn}>
                                    <div className="semibold-h200 paddingBottom16">{t("CardDetailsText")}</div>
                                    <div className="semibold-b100 cl-secondary-500 paddingBottom10">{t("CardDetailsEditDescriptionText")}</div>
                                    <div className="semibold-b100 cl-secondary-500">{state.currentIban ? t("Bank") + ": " + state.currentIban : (state.curentExpDate ? t("Card") + " " + t("CardExpireDate") + state.curentExpDate : "")}</div>
                                </div>
                                <div>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        value={state.currentIban ? "1" : (state.curentExpDate ? "2" : "")}
                                        name="radio-buttons-group-paymenttype"
                                    >
                                        <div className="marginBottom32 myPaymentCard">
                                            <div className="flexWrapper">
                                                <div>
                                                    <div className="semibold-b300 paddingBottom20">{t("Bank")}</div>
                                                </div>
                                                <div className="textRight">
                                                    <a className='semibold-b300 anchor'
                                                        onClick={e => !state.termsAgreed ? setTermsIncorrect() : setBankAccountOpen(true)}>
                                                        {state.currentIban ? t("EditBtnText") : t("ChangeDefaultMethodBtnText")}<img loading="lazy"
                                                            className="gotopageimg"
                                                            alt={state.currentIban ? t("EditBtnText") : t("ChangeDefaultMethodBtnText")} src="/img/rightarrow.svg" /></a>
                                                </div>
                                            </div>
                                            <div className="regular-b200 paddingBottom20">{t("BankAccountDescription")}</div>
                                            <div>
                                                {/* {state.currentIban ?
                                                    <span className="regular-b200 cl-secondary-500">{state.currentIban}</span>
                                                    : ""} */}
                                                {/* {state.currentIban ? <span>{buttonEditBankAccount}</span> : <span>{buttonAddBankAccount}</span>} */}
                                            </div>
                                        </div>
                                        <div className="myPaymentCard">
                                            <div className="flexWrapper">
                                                <div>
                                                    <div className="semibold-b300 paddingBottom20">{t("Card")}</div>
                                                </div>
                                                <div className="textRight">
                                                    <a className='semibold-b300 anchor'
                                                        onClick={e => !state.termsAgreed ? setTermsIncorrect() : handleSubmissionCreditCard(e)}>
                                                        {state.curentExpDate ? t("EditBtnText") : t("ChangeDefaultMethodBtnText")}<img loading="lazy"
                                                            className="gotopageimg"
                                                            alt={state.curentExpDate ? t("EditBtnText") : t("ChangeDefaultMethodBtnText")} src="/img/rightarrow.svg" /></a>
                                                </div>
                                            </div>
                                            <div className="regular-b200 paddingBottom20">{t("CreditCardDescription")}</div>
                                            <div>
                                                {/* {state.curentExpDate ? <span className="regular-b200 cl-secondary-500">{state.curentExpDate}</span>
                                                : ""} */}
                                                {/* {state.curentExpDate ? <span>{buttonEditCreditCard}</span> : <span>{buttonAddCreditCard}</span>} */}
                                            </div>
                                        </div>
                                    </RadioGroup>
                                </div>
                                {bankAccountModal}
                            </div>
                        </Grid>
                        {/* </Grid> */}
                    </CardBody>
                </form>
             <form id="elForm" action={props.userData.redsysService} method="POST" >
                    <input type="hidden" name="Ds_SignatureVersion" value={'HMAC_SHA256_V1'} />
                    <input id="merchantParams" type="hidden" name="Ds_MerchantParameters" value={""} />
                    <input id="signature" type="hidden" name="Ds_Signature" value={""} />
                </form>
                <SavedModal show={savedModalOpen} close={() => setSavedModalOpen(false)} />
                <CardErrorModal show={cardErrorModalOpen} close={() => setCardErrorModalOpen(false)} />
            </GridItem>
        </GridContainer>
    );
}
export default withRouter(PaymentFormOverviewComponent);